import type { Application } from '@/types/Activity'

export const ADVERSE_CREDIT_FRAUD_ESCALATION_WARNING =
  'This subject has adverse credit. Resetting the residential section will flag the subject as potential fraud with the current adverse credit details.'

export const hasAdverseCredit = (application: Application): boolean =>
  (application.context?.credit?.adverseCredit?.length ?? 0) > 0
